import httpInstance from "../httpInstance";

export const putCategory = async (jwtToken: string, id: any, categoryName: string) => {
    let res: any;
    const endpoint = `resourceCategory/${id}/`;

    const config = {
        headers: {
            Authorization: jwtToken
        }
    };

    const body = {
        "name": categoryName,
    }

    await httpInstance.put(endpoint, body, config)
        .then((response) => {
            res = response;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
} 

export const putCategoryImage = async (jwtToken: string, id: any, image: any) => {
    let res: any;
    const endpoint = `resourceCategoryImage/${id}/`;

    const config = {
        headers: {
            Authorization: jwtToken,
        }
    };

    const formData = new FormData();
    formData.append("image", image);

    await httpInstance.post(endpoint, formData, config)
        .then((response) => {
            res = response;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}